import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface ChangeRecordReq {
  device_id: string // 终端id
  page: number // page
  limit: number // 每页数量
}

export interface ChangeRecordItem {
  time: string // 变更时间，时间戳(秒)
  ip: string // ip,以英文逗号分隔
  change_item: string // 变更项
  origin_setting: string // 原配置
  new_setting: string // 新配置
}

@Injectable()
export class ChangeLogService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getChangeRecord (options: ChangeRecordReq) {
    return this.http.post<{
      total: number
      list: ChangeRecordItem[]
    }>('/terminal/hardware-change-record/get', options)
  }
}
